import { useState, useEffect, useReducer } from "react";
import { db } from "../firebase/config";
import { updateDoc, doc } from "firebase/firestore";
import { uploadToCloudinary } from "../services/upload";

const enviroment = process.env.REACT_APP_ENVIROMENT;

const initialState = { loading: null, error: null };

const updateReducer = (state, action) => {
  switch (action.type) {
    case "LOADING": return { loading: true, error: null };
    case "ERROR": return { loading: false, error: action.payload };
    case "UPDATED_DOC": return { loading: false, error: null };
    default: return state;
  }
};

export const useUpdateDocument = (docCollection) => {
  const [response, dispatch] = useReducer(updateReducer, initialState);
  const [cancelled, setCancelled] = useState(false);

  const checkCancelBeforeDispatch = (action) => {
    if (enviroment === "prod" ? !cancelled : cancelled) dispatch(action);
  };

  const updateDocument = async (id, data, file) => {
    checkCancelBeforeDispatch({ type: "LOADING" });
    try {
      let fileUrl = null;

      // Se 'file' for um objeto File (novo upload), envia. 
      // Se for string ou null, mantém a imagem atual.
      if (file && typeof file !== "string") {
        fileUrl = await uploadToCloudinary(file);
      }

      const docRef = doc(db, docCollection, id);
      const updatedData = fileUrl ? { ...data, imagem: fileUrl } : data;

      await updateDoc(docRef, updatedData);

      checkCancelBeforeDispatch({ type: "UPDATED_DOC" });
    } catch (error) {
      checkCancelBeforeDispatch({ type: "ERROR", payload: error.message });
    }
  };

  useEffect(() => () => setCancelled(true), []);
  return { updateDocument, response };
};